import * as React from 'react';
import classnames from 'classnames';
import Icon from './icon';
import Label from './label';
import { LayoutBlock, LayoutBlockProps } from './layout-block';

import './button.scss';

export interface Props extends LayoutBlockProps {
	busy?: boolean;
	disabled?: boolean;
	busyTitle?: string;
	href?: string;
}

const Button: React.FC<Props> = (props: Props) => {
	const { style, ...layoutConfig } = props;

	var busyTitle = layoutConfig.busyTitle || null;
	var busy = layoutConfig.busy || null;
	delete layoutConfig.busyTitle;
	delete layoutConfig.busy;

	return (
		<LayoutBlock
			{...layoutConfig}
			className={classnames('button', layoutConfig.className)}
			style={{ ...style, pointerEvents: busy ? 'none' : null }}
		>
			<Label inline verticalAlign='center' align='center'>
				{props.busy ? (
					<Label>
						{' '}
						<Icon icon='gear' spin />
						{busyTitle ? busyTitle : 'Processing...'}
					</Label>
				) : (
					props.children
				)}
			</Label>
		</LayoutBlock>
	);
};

Button.defaultProps = {};

export default Button;
